import type { ChangeContext } from '../../client/changeManager';
import type { ResourceDefinition } from '../../resources/types';
import type { CacheEntry } from './cacheEntry';
import { produceNextCacheEntry } from './produceNextCacheEntry';
import { markStale } from '../../resolvers/definition/resolverState';

export const tryMarkStale = (
  entry: CacheEntry<any, any>,
  hash: ResourceDefinition['hash'],
  changeContext: ChangeContext
): CacheEntry<any, any> | null => {
  if (entry.meta.changeContext.originId >= changeContext.originId) {
    return null;
  }

  const { nextEntry, flagsChanged } = produceNextCacheEntry({
    params: entry.meta.params,
    hash,
    currentEntry: entry,
    nextState: markStale()(entry.state),
    changeContext,
  });

  if (flagsChanged) {
    return nextEntry;
  }

  const { loading, error } = nextEntry.state;

  if (loading || !error) {
    return null;
  }

  return { ...nextEntry, meta: { ...nextEntry.meta, changeContext } };
};
